import React from "react";
import { Box, Typography } from "@material-ui/core";
import "./styles.scss";

interface ITripDescriptionSummary {
  tripDescription: string;
}

export const TripDescriptionSummary = ({
  tripDescription,
}: ITripDescriptionSummary) => (
  <Box className="trip-description-summary-container">
    <Typography variant="body2" className="trip-description-label">
      Purpose
    </Typography>
    <Typography variant="subtitle2" className="trip-description-text">
      {tripDescription}
    </Typography>
  </Box>
);
